export enum CkNormeValuesEnum {
    normeSrl = '1',
    normeSpaOrdinario = '2',
    normeSpaDualistico = '3',
    normeSpaMonistico = '4',
}
